<template>
  <b-form
      class="chat-app-form"
      @submit.prevent="sendMessage"
  >
    <b-input-group class="input-group-merge form-send-message mr-1">
      <b-form-input
          v-model="chatInputMessage"
          placeholder="Enter your message"
          @input="notifyTyping"
      />
    </b-input-group>
    <b-button
        variant="primary"
        type="submit"
    >
      Send
    </b-button>
  </b-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ChatInput',
  data() {
    return {
      chatInputMessage: '',
      lastTypedTime: null,
    }
  },
  computed: {
    ...mapGetters("chat", ["activeSession"]),
  },
  methods: {
    ...mapActions("chat", ["sendChatMessage", "notifyTypingMessage"]),
    notifyTyping(){
      console.log('notifyTyping')
      const currentTime = new Date().getTime();
      if (this.lastTypedTime && currentTime - this.lastTypedTime <= 2000) {
        return
      }
      this.lastTypedTime = currentTime
      this.notifyTypingMessage(this.activeSession.id)
          .catch((error) => {
            console.error('Error notifying typing:', error)
          })
    },
    sendMessage() {
      if (!this.chatInputMessage || this.chatInputMessage.trim() === '') return
      let chatInputMessage = this.chatInputMessage.trim()
      this.chatInputMessage = ''
      let $this = this
      const payload = {
        sessionId: $this.activeSession.id,
        messageRequest: { content: chatInputMessage },
      }
      this.sendChatMessage(payload)
          .then(() => {
            $this.$emit('message-sent', chatInputMessage)
          })
          .catch((error) => {
            console.error('Error sending message:', error)
            $this.$emit('message-error', error)
          })
      this.$emit('message-sent', chatInputMessage)
    },
  }
}
</script>


<style scoped>

</style>